var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { CardTitle, LILAC_600, Stepper, getTestId, isValidObject } from '@airtel/air-design-system';
import { useMemo } from 'react';
import { CalloutWidget } from '../callout-widget';
import { TrackOrderCardWidget } from '../track-order-card-widget';
import { StyleSheet, View } from 'react-native';
import { ButtonWidget } from '../button-widget';
import { InfoSummaryWidget } from '../info-summary-widget';
export var TrackOrderStepperWidgetComponent = props => {
  var _props$steps = props.steps,
    steps = _props$steps === void 0 ? [] : _props$steps,
    onUserAction = props.onUserAction,
    _props$showStepperTit = props.showStepperTitle,
    showStepperTitle = _props$showStepperTit === void 0 ? false : _props$showStepperTit,
    _props$stepperTitlePr = props.stepperTitleProps,
    stepperTitleProps = _props$stepperTitlePr === void 0 ? {} : _props$stepperTitlePr,
    _props$showBottomButt = props.showBottomButton,
    showBottomButton = _props$showBottomButt === void 0 ? false : _props$showBottomButt,
    _props$bottomButtonPr = props.bottomButtonProps,
    bottomButtonProps = _props$bottomButtonPr === void 0 ? {} : _props$bottomButtonPr,
    restProps = __rest(props, ["steps", "onUserAction", "showStepperTitle", "stepperTitleProps", "showBottomButton", "bottomButtonProps"]);
  var appendChildElement = (item, index) => {
    var updatedItem = Object.assign({}, item);
    if (isValidObject(updatedItem === null || updatedItem === void 0 ? void 0 : updatedItem.trackOrderCardProps)) {
      updatedItem.childElement = _createElement(TrackOrderCardWidget, Object.assign({}, updatedItem.trackOrderCardProps, {
        onUserAction: onUserAction,
        key: "trackOrderCard_" + index
      }));
    }
    if (isValidObject(updatedItem === null || updatedItem === void 0 ? void 0 : updatedItem.calloutProps)) {
      updatedItem.childElement = _createElement(CalloutWidget, Object.assign({}, updatedItem.calloutProps, {
        onUserAction: onUserAction,
        key: "callout_" + index
      }));
    }
    if (isValidObject(updatedItem === null || updatedItem === void 0 ? void 0 : updatedItem.infoSummaryProps)) {
      updatedItem.childElement = _createElement(InfoSummaryWidget, Object.assign({}, updatedItem.infoSummaryProps, {
        onUserAction: onUserAction,
        key: "infoSummary_" + index
      }));
    }
    return updatedItem;
  };
  var processChildren = items => {
    return items === null || items === void 0 ? void 0 : items.map((item, index) => {
      var processedItem = appendChildElement(item, index);
      if (processedItem.children && processedItem.children.length > 0) {
        processedItem.children = processChildren(processedItem.children);
      }
      return processedItem;
    });
  };
  var renderedSteps = useMemo(() => processChildren(steps), [steps]);
  return _jsxs(View, {
    children: [showStepperTitle ? _jsx(CardTitle, Object.assign({}, stepperTitleProps, {
      style: styles.cardTitleStyle
    })) : null, _jsx(Stepper, Object.assign({
      stepperConnectorColor: LILAC_600
    }, restProps, {
      steps: renderedSteps
    }, getTestId(props === null || props === void 0 ? void 0 : props.testID))), showBottomButton ? _jsx(ButtonWidget, Object.assign({}, bottomButtonProps, {
      onUserAction: onUserAction
    })) : null]
  });
};
var styles = StyleSheet.create({
  cardTitleStyle: {
    marginBottom: 16
  }
});
TrackOrderStepperWidgetComponent.genericRendererKey = 'AirTrackOrderStepperWidget';